import React from "react";

import { Button, type ManagedModalComponentProps, Modal } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import style from "./PaywallModal.module.css";

type PaywallModalProps =
  | {
      modalProps: ManagedModalComponentProps;
      title: string;
      description?: string;
      showSubscriptionButton: true;
      onClose?: () => void;
      onClick: () => void;
      size?: "small" | "medium";
    }
  | {
      modalProps: ManagedModalComponentProps;
      title: string;
      description?: string;
      showSubscriptionButton: false;
      onClose?: () => void;
      onClick?: never;
      size?: "small" | "medium";
    };

export const PaywallModal = React.forwardRef<HTMLElement, PaywallModalProps>(
  (
    { modalProps, title, description, showSubscriptionButton, size = "small", onClose, onClick },
    ref
  ) => {
    return (
      <Modal
        {...modalProps}
        onClose={() => {
          onClose?.();
          modalProps.onClose();
        }}
        size={size}
        title={title}
        ref={ref}
        className={`${style.paywallModal} ${!showSubscriptionButton ? style.noSubscribeButton : ""}`}
        footer={
          showSubscriptionButton ? (
            <Button variant="primary" onClick={onClick} className={style.paywallButton}>
              Subscribe now
            </Button>
          ) : undefined
        }
      >
        <div
          className={classNames(style.container, showSubscriptionButton && style.containerMargin)}
        >
          <span className={style.paywallDescription}>{description}</span>
        </div>
      </Modal>
    );
  }
);
